document.addEventListener('DOMContentLoaded', () => {
  const articleContent =
    document.querySelector('#BlogArticleContent') ||
    document.querySelector('.article-template__content.rte') ||
    document.querySelector('.article-template__content') ||
    document.querySelector('.rte');

  const tocList = document.querySelector('#BlogTocList');
  const tocSidebar = document.querySelector('#BlogTocSidebar');

  if (!articleContent || !tocList || !tocSidebar) return;

  const headings = articleContent.querySelectorAll('h2');

  if (!headings.length) {
    tocSidebar.style.display = 'none';
    return;
  }

  const slugify = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  };

  const usedIds = new Set();

  headings.forEach((heading, index) => {
    let baseId = heading.id ? heading.id : slugify(heading.textContent);
    if (!baseId) baseId = `section-${index + 1}`;

    let finalId = baseId;
    let counter = 2;

    while (usedIds.has(finalId) || document.querySelectorAll(`#${CSS.escape(finalId)}`).length > 1) {
      finalId = `${baseId}-${counter}`;
      counter++;
    }

    usedIds.add(finalId);
    heading.id = finalId;

    const li = document.createElement('li');
    const a = document.createElement('a');

    a.href = `#${finalId}`;
    a.textContent = heading.textContent.trim();

    li.appendChild(a);
    tocList.appendChild(li);
  });

  const tocLinks = tocList.querySelectorAll('a');

  const setActiveLink = () => {
    let currentId = '';

    headings.forEach((heading) => {
      const rect = heading.getBoundingClientRect();
      if (rect.top <= 140) {
        currentId = heading.id;
      }
    });

    tocLinks.forEach((link) => {
      link.classList.remove('is-active');
      if (link.getAttribute('href') === `#${currentId}`) {
        link.classList.add('is-active');
      }
    });
  };

  tocLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const targetId = link.getAttribute('href').replace('#', '');
      const target = document.getElementById(targetId);

      if (!target) return;

      event.preventDefault();

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

      history.replaceState(null, '', `#${targetId}`);
    });
  });

  setActiveLink();
  window.addEventListener('scroll', setActiveLink, { passive: true });
});